import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { ListItemSecondaryAction } from "@material-ui/core";
import {
    Draggable,
    DraggableProvided,
    DraggableStateSnapshot
} from "react-beautiful-dnd";
import { Tooltip } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import { Badge } from "@material-ui/core";

interface IPropsStageItems {
    listStages: Compleo.IObject[];
    classError: any;
    t: any;
    handleEditStage: any;
    handleDeleteStage: any;
    stageIdsWithApprovers?: string[];
}

const StagesItems = (props: IPropsStageItems) => {
    const {
        listStages,
        classError,
        t,
        handleEditStage,
        handleDeleteStage,
        stageIdsWithApprovers = []
    } = props;

    return (
        <>
            {listStages.map((stage: any, index: number) => {
                const approversCount = stage.approvers?.length || 0;
                return (
                    <Draggable
                        key={stage.id || `stage-${index}`}
                        draggableId={stage.name || `stage-${index}`}
                        index={index}
                    >
                        {(
                            provided: DraggableProvided,
                            snapshot: DraggableStateSnapshot
                        ) => (
                            <ListItem
                                button
                                alignItems="flex-start"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                            >
                                <ListItemIcon>
                                    <Badge
                                        badgeContent={approversCount}
                                        color="primary"
                                    >
                                        <Icon color="action">
                                            assignment_ind
                                        </Icon>
                                    </Badge>
                                </ListItemIcon>
                                <ListItemText
                                    className={classError}
                                    primary={stage.name}
                                    secondary={
                                        <React.Fragment>
                                            {t("approvalLogic")}:{" "}
                                            {stage.approvalLogic?.value ===
                                            "and"
                                                ? t("approvalLogic_and")
                                                : t("approvalLogic_or")}
                                            <br />
                                            {t("expirationDays")}:{" "}
                                            {stage.expirationDays}
                                            {stageIdsWithApprovers.includes(
                                                stage.id
                                            ) && (
                                                <>
                                                    <br />
                                                    {t("hasApproversMessage")}
                                                </>
                                            )}
                                        </React.Fragment>
                                    }
                                />
                                <ListItemSecondaryAction>
                                    <Tooltip title={t("COMPLEOGENERAL_Delete")}>
                                        <IconButton
                                            aria-label={t(
                                                "COMPLEOGENERAL_Delete"
                                            )}
                                            color="secondary"
                                            onClick={() =>
                                                handleDeleteStage(stage)
                                            }
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={t("COMPLEOGENERAL_Edit")}>
                                        <IconButton
                                            aria-label={t(
                                                "COMPLEOGENERAL_Edit"
                                            )}
                                            color="primary"
                                            onClick={() =>
                                                handleEditStage(stage, index)
                                            }
                                        >
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </ListItemSecondaryAction>
                            </ListItem>
                        )}
                    </Draggable>
                );
            })}
        </>
    );
};

export default StagesItems;
